/**
 * Created by adalto on 6/3/14.
 */

Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};
Greenmile.Task.RelatedInfo.Location = {

    removeLinkedLocationFromList: function (el) {

        var lineItem = el.parentNode.parentNode.parentNode.parentNode;

        if (lineItem.className === 'controls') {
            lineItem = el.parentNode.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;

        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedLocationFromData: function (el) {

        var node = el.parentNode.parentNode;
        var nodes = Monet.Session.Task.lastLinkForm.locations.nodes;
        var ids = Monet.Session.Task.lastLinkForm.locations.ids;
        var data = Monet.Session.Task.lastLinkForm.locations.data;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {
            if (nodes[i].id === node.id) {
                index = i;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.locations.splice(index, 1);
        }

    },

    createLocationIdNode: function (data) {

        var divContainer = document.createElement('div');
        var divTitle = document.createElement('div');
        var divDel = document.createElement('div');
        var divDestroy = document.createElement('div');
        var divClear = document.createElement('div');
        var input = document.createElement('input');
        var inputStatus = document.createElement('input');
        var inputLinked = document.createElement('input');
        var linkedTaskWhen = document.createElement('input');

        divContainer.id = "location_" + data.location.id;
        divContainer.className = "item_lookuplist_location_" + data.location.id;

        divTitle.className = "title_item_added";
        divTitle.innerHTML = data.location.key;

        divDel.className = "del_item_added";

        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";

        divClear.style.clear = "both";

        divDestroy.addEventListener('click', (function (scope, data) {

            return function (e) {

                e.preventDefault();

                const confirmDeleteLocation = () => {
                    App.Views.Task.showLoadingElement(this);
                    Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                        return function () {

                            App.Views.Task.hideLoad();

                            scope.removeLinkedLocationFromList(e.target);
                            scope.removeLinkedLocationFromData(e.target, scope);
                            Greenmile.Task.RelatedInfo
                                .removeTitleContainerIfEmptyTo(
                                    Greenmile.Task.RelatedInfo.collections.LOCATIONS
                                );
                        };
                    }(e)));
                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteLocation);

            };

        }(this, data)));

        linkedTaskWhen.type = 'hidden';
        linkedTaskWhen.id = "taskLinkeds[" + data.location.id + "].when";
        linkedTaskWhen.name = "taskLinkeds[" + data.location.id + "].when";
        linkedTaskWhen.className = "modelAttribute";
        linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

        input.type = "hidden";
        input.name = "taskLinkeds[" + data.location.id + "].location.id";
        input.id = "taskLinkeds[" + data.location.id + "].location.id";
        input.className = "modelAttribute";
        input.value = data.location.id;

        inputStatus.type = 'hidden';
        inputStatus.name = 'taskLinkeds[' + data.location.id + '].status';
        inputStatus.id = 'taskLinkeds[' + data.location.id + '].status';
        inputStatus.className = "modelAttribute";
        inputStatus.value = '';

        inputLinked.type = 'hidden';
        inputLinked.name = 'taskLinkeds[' + data.location.id + '].id';
        inputLinked.id = 'taskLinkeds[' + data.location.id + '].id';
        inputLinked.className = "modelAttribute";
        inputLinked.value = data.id || '';

        divDel.appendChild(divDestroy);

        divContainer.appendChild(divTitle);
        divContainer.appendChild(divDel);
        divContainer.appendChild(divClear);
        divContainer.appendChild(input);
        divContainer.appendChild(inputStatus);
        divContainer.appendChild(inputLinked);
        divContainer.appendChild(linkedTaskWhen);

        Monet.Session.Task.lastLinkForm.locations.nodes.push(divContainer);
        Monet.Session.Task.lastLinkForm.locations.data.push(data);
        Monet.Session.Task.lastLinkForm.locations.ids.push(input);

    },

    createFullLocationInfo: function (data) {

        Monet.Session.Task.lastLinkForm.locations.nodes = [];
        Monet.Session.Task.lastLinkForm.locations.data = [];
        Monet.Session.Task.lastLinkForm.locations.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('location')) {
                this.createLocationIdNode(data[i]);
            }

        }

    }

};